/**
 * Created by alvinoktavianus on 7/21/17.
 */
/* global mixpanel */

export function settingBillingPay ({billingData}) {
  mixpanel.track('Setting Billing Pay', {
    'Billing Cycle': billingData.subscription_name !== 'Monthly' ? 'Annual' : billingData.subscription_name,
    'Payment Amount': billingData.total_amount,
    'Total Outlet': billingData.purchased_outlets.length
  })
}



// WEBPACK FOOTER //
// ./app/mixpanel/settings/billing.js